/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPortfolioV1AssetBalanceState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PORTFOLIO_V1_ASSET_BALANCE_STATE_ENTITY_NAME = 'ixc.portfolio.v1.AssetBalance';
export const ixcPortfolioV1AssetBalanceStateEntity = new schema.Entity<IxcPortfolioV1AssetBalanceState>(IXC_PORTFOLIO_V1_ASSET_BALANCE_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcPortfolioV1AssetBalanceState) => `${entity.accountId}-${entity.assetId}` });

